import React from "react"
import PropTypes from "prop-types"

import { NewSubmissionForm } from "./forms"
import { ErrorMessage } from "./styled"

export const StartNewSubmissionComponent = ({isLoading, onSubmit, isReCaptchaVisible, error}) => {
  return (
    <>
      <div className="container hero3">
        <div className="row">
          <div className="col-md-12">
            <h1 className="magenta">Start a new Submission</h1>
            <p>To start a new submission, select the phone number you are submitting for, and enter the code provided to you to apply for the promotion. </p>
          </div>
        </div>
      </div>
        <div className="container">
          <div className="row">
            <div className="mx-auto col-md-12">
              {error
                ? <ErrorMessage>{error}</ErrorMessage>
                : <NewSubmissionForm isLoading={isLoading} onSubmit={onSubmit} isReCaptchaVisible={isReCaptchaVisible}
                />
              }
            </div>
          </div>
        </div>
    </>
  )
}

StartNewSubmissionComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isReCaptchaVisible: PropTypes.bool,
  error: PropTypes.string
}
